import { createContext } from 'react';

export const DrawerContext = createContext<{
  isLoading?: boolean;
  activeSubDrawer?: string;
  activeSubDrawerArgs?: any;
  setActiveSubDrawer: (subDrawer: string | undefined, args?: string) => void;
}>(undefined as never);
